import React, { useState } from "react";
import "./RPASection.css";

const RPASection = ({ data }) => {
  const { title, tabs } = data;
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [imageKey, setImageKey] = useState(0); // New state to trigger animation

  const current = tabs.find((t) => t.id === activeTab);

  const handleTabChange = (id) => {
    if (id !== activeTab) {
      setActiveTab(id);
      setImageKey((prev) => prev + 1); // Force re-render of image
    }
  };

  return (
    <section className="rpa-section">
      <div className="rpa-container">
        <h2 className="rpa-title">{title}</h2>

        <div className="rpa-tabs-wrapper">
          <ul className="rpa-tabs">
            {tabs.map(({ id, label }) => (
              <li
                key={id}
                className={`rpa-tab ${id === activeTab ? "active" : ""}`}
                onClick={() => handleTabChange(id)}
              >
                {label}
              </li>
            ))}
          </ul>
        </div>

        <div className="rpa-content">
          <div className="rpa-left">
            <h3 className="rpa-heading">{current.heading}</h3>
            <p className="rpa-text">{current.text}</p>
          </div>
          <div className="rpa-right">
            <img
              key={imageKey} // New key triggers animation
              className="rpa-image fade-in"
              src={current.image}
              alt={current.label}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RPASection;
